var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebFlightArrivalIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.877,
    height: 33.683,
    viewBox: "0 0 39.877 33.683",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5424",
    "data-name": "Group 5424",
    transform: "translate(-148.001 -113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "outbound_plane_desktop",
    d: "M37.97,3.578S10.36,13.7,8.007,14.584s-3.7.288-4.445-.59C2.47,12.711,0,9.436,0,9.436s1.07-.413,1.99-.777a3.771,3.771,0,0,1,2.985.208c1.437.819,2.511,1.395,2.511,1.395L16.53,7.107l-8.1-5.722A13.746,13.746,0,0,1,10.614.3c1.585-.567,3.217-.35,5.54.851,2.464,1.272,6.858,3.55,6.858,3.55l7.936-2.935A6.426,6.426,0,0,1,37.97,3.578Z",
    transform: "translate(156.398 113) rotate(34)",
    fill: "#36495a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebFlightArrivalIcon);
export default __webpack_public_path__ + "static/media/Web_FlightArrival_Icon.fffdf9ea94ea2b98700195dab405472f.svg";
export { ForwardRef as ReactComponent };